class Newsletter {
    init(token, subscribeRoute) {
        this.form = $('#newsletter-form');
        this.input = $('.jsNewsletterInput');
        this.link = $('.jsNewsletterLink');
        this.formShown = false;
        this.token = token;
        this.subscribeRoute = subscribeRoute;

        this.form.on('submit', (e) => {
            e.preventDefault();
        });

        this.input.keypress((e) => {
            if(e.which == 13) {
                this.submit(e);
            }
        })

        this.link.click((e) => {
            this.submit(e);
        });
    }

    submit(e) {
        e.preventDefault();

        if(this.formShown) {

            // add submit button, trigger it, remove it (in order to display native validation error messages)
            $('<input type="submit">').hide().appendTo(this.form).click().remove();

            // check validity of form using the browser's native validation
            if(this.form[0].checkValidity()) {
                // subscribe e-mail
                $.post(
                    this.subscribeRoute,
                    {
                        _token: this.token,
                        email: this.input.val()
                    },
                    (data) => {
                        // display success message
                        if(data.success) {
                            this.input.hide();
                            this.link.text(this.link.data('thank-you'));
                            this.link.unbind('click');
                            this.link.click((e) => {
                                e.preventDefault();
                            });
                        } else {
                            this.link.text(this.link.data('error'));
                        }
                    }
                );
            }

        } else {
            // show form
            this.form.addClass('d-inline');
            this.formShown = true;
            this.input.focus().select();
            this.link.children('span').text(this.link.data('subscribe'));
        }
    }
}

export default Newsletter;